import React from 'react';
import { TextMobile as Text } from '@alfa-bank/site-text-v2/mobile';
import { sentryCaptureException } from '@alfa-bank/site-helpers-error-handlers/sentry-logger/capture-exception';
import { sentryAddErrorBreadcrumb } from '@alfa-bank/site-helpers-error-handlers/sentry-logger/breadcrumb';

import type { TGetTooltipPropsFn } from './models';

export const renderPlaceholder = (items: Array<{ id: string; text: string }>) => {
    if (!items.length) return;

    const lastIndex = items.length - 1;

    return items.map((item, index) => {
        return index === lastIndex ? (
            <span key={item.id}>{item.text}</span>
        ) : (
            <span key={item.id}>{`${item.text}, `}</span>
        );
    });
};

export const getCategoryWordPlaceHolder = (requiredCount: number) => {
    if (requiredCount >= 5) return 'категорий';
    if (requiredCount >= 2 && requiredCount <= 4) return 'категории';

    return 'категория';
};

export const getCategoryWordTitle = (requiredCount: number) => {
    if (requiredCount <= 1) return 'категорию';
    if (requiredCount >= 2 && requiredCount <= 4) return 'категории';

    return 'категорий';
};

export const getPlaceholderText = (count: number) => {
    const categoryWord = getCategoryWordPlaceHolder(count);

    if (count > 1) return `Доступно ${count} ${categoryWord}`;

    return `Доступна ${count} ${categoryWord}`;
};

export const getMobileTooltipProps: TGetTooltipPropsFn = ({
    actionButtonTitle = 'Понятно',
    content,
    title,
}) => {
    return {
        bottomSheetProps: {
            hasCloser: true,
        },
        title: (
            <Text styler={{ marginBottom: 0, marginTop: 24, padding: 0 }} view="small">
                {title}
            </Text>
        ),
        content: (
            <Text styler={{ marginBottom: 0, marginTop: 0, padding: 0 }} view="primary-small">
                {content}
            </Text>
        ),
        actionButtonTitle,
        view: 'tooltip',
    };
};

export const getDesktopTooltipProps: TGetTooltipPropsFn = ({ content }) => {
    return {
        content,
        view: 'hint',
    };
};

export const onSentryCaptureException = (error: unknown) => {
    console.error(error);

    sentryAddErrorBreadcrumb({
        message: 'cashbackCategories error',
    });

    sentryCaptureException(error, {
        packageName: 'dc-form',
        teamName: 'dc',
    });
};
